var map = {
	"./template.betgalaxy": 2033,
	"./template.betgalaxy.tsx": 2033,
	"./template.betroyale": 1110,
	"./template.betroyale.tsx": 1110,
	"./template.default": 659,
	"./template.default.tsx": 659,
	"./template.fiestabet": 1111,
	"./template.fiestabet.tsx": 1111,
	"./template.puntgenie": 1112,
	"./template.puntgenie.tsx": 1112,
	"./template.questbet": 1113,
	"./template.questbet.tsx": 1113,
	"./template.sterlingparker": 1114,
	"./template.sterlingparker.tsx": 1114,
	"./template.ts": 212,
	"./template.volcanobet": 1115,
	"./template.volcanobet.tsx": 1115,
	"./template.wellbet": 1116,
	"./template.wellbet.tsx": 1116
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2427;